import {connect} from "react-redux"
import State from "../../models/State"
import getRealmFromHeaders from "../../utils/getRealmFromHeaders"

export const mapStateToProps = (state: State) => {
    return {
        realm: getRealmFromHeaders(state.request.headers),
        altText: state.text.labels.loading,
    }
}

export default connect(mapStateToProps)
